import React from 'react';
import AnalysisScreen from '../screens/AnalysisScreen';
import { Project } from '../types';

interface AnalysisContainerProps {
  project: Project;
  onBack: () => void;
  username?: string;
  onLogout?: () => void;
  onNavigate?: (screen: string, testId?: string, projectId?: string) => void;
}

const AnalysisContainer: React.FC<AnalysisContainerProps> = ({ 
  project, 
  onBack,
  username,
  onLogout,
  onNavigate 
}) => {
  return (
    <AnalysisScreen
      project={project}
      onBack={onBack}
      username={username}
      onLogout={onLogout}
      onNavigate={onNavigate}
    />
  );
};

export default AnalysisContainer; 